import { Button } from "@eworkit/iris";
import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IURLSortConfig } from "@/core/url";
import {
  fetchJobRequestListV1,
  fetchPublicJobRequestList,
  IJobRequest,
  IJobRequestURLFilter,
  IPageableJobRequest,
} from "@/data/job-requests";
import { TPageableFetchFunction, usePageableFetcher } from "@/hooks/http";
import { JobsWidget } from "@/views/JobRequests";
import { router } from "@/views/router";

export interface RecentJobsWidgetProps {
  publicProfileIds: number[];
  slug: string;
  isPublic?: boolean;
}

export const RecentJobsWidget: FC<RecentJobsWidgetProps> = ({ publicProfileIds, slug, isPublic = false }) => {
  const { t } = useTranslation("public");

  const baseRoute = isPublic ? "public-client" : "client";

  const jobsFetchFunction = isPublic ? fetchPublicJobRequestList : fetchJobRequestListV1;

  const fetchJobs: TPageableFetchFunction<IJobRequest, IPageableJobRequest, IJobRequestURLFilter, IURLSortConfig[]> =
    useCallback(
      ({ filtersConfig, ...restParams }, options) => {
        return jobsFetchFunction(
          {
            ...restParams,
            filtersConfig: {
              ...filtersConfig,
              publicProfileIds,
            },
            size: 3,
          },
          options,
        );
      },
      [publicProfileIds],
    );

  const jobsFetcher = usePageableFetcher(fetchJobs, [publicProfileIds]);

  return (
    <JobsWidget
      header={t("CLIENT_PAGE.DETAILS.RECENT_JOBS.HEADER")}
      jobs={jobsFetcher.payload?.content.map(j => j.data)}
      isPublic={isPublic}>
      <Button as={Link} to={router.get(`${baseRoute}.jobs`, { slug }).path} variant="secondary">
        {t("CLIENT_PAGE.DETAILS.RECENT_JOBS.LABEL_SHOW_ALL")}
      </Button>
    </JobsWidget>
  );
};
